module.exports = __webpack_public_path__ + "static/media/team-suzie.862119de.jpg";